import { IconProps, Tooltip } from '@chakra-ui/react';
import { Icons } from '../Icons';

export interface UserTooltipProps extends IconProps {
  name: string;
  email: string;
  iconSize?: number;
}

export function UserTooltip({
  name,
  email,
  iconSize,
  ...props
}: UserTooltipProps) {
  return (
    <Tooltip label={`${name} (${email})`}>
      <Icons.AccountCircle {...props} boxSize={iconSize ?? 4} />
    </Tooltip>
  );
}
